import { Box, CircularProgress, Paper, PaperProps } from '@mui/material';
import { createContext, useContext } from 'react';

export const LoadingMoreContext = createContext(false);

const PaperWithLoader = ({ children, ...props }: PaperProps) => {
  const loadingMore = useContext(LoadingMoreContext);
  return (
    <Paper {...props}>
      {children}
      {loadingMore && (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 1 }}>
          <CircularProgress size={20} aria-label="Loading more options" />
        </Box>
      )}
    </Paper>
  );
};

export default PaperWithLoader;
